/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandCheckoutNotesRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandCheckoutNotesResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandCheckoutNotes = (request: SetBrandCheckoutNotesRequest, options?: CashRequestOptions) => post<SetBrandCheckoutNotesRequest, SetBrandCheckoutNotesResponse>("/2.0/cash/set-brand-checkout-notes", request, {...options, rejectOnError: true })